/**
 * @implements ImportSourceDataType
 * @type CredlyBadgeType
 */
export const CredlyBadgeType = {
    name: 'badge',
    sourceName: 'Badges',
};
